import React, { useState } from 'react';
import './Location.css';

const Location = () => {
  const [selectedCity, setSelectedCity] = useState('London');
  const mapSrc =
    selectedCity === 'London'
      ? 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19801.96489375413!2d-0.3082542!3d51.4633671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760f8e2e2e2e2e%3A0x2e2e2e2e2e2e2e2e!2s179%20Lower%20Richmond%20Rd%2C%20London%20TW9%204LN%2C%20UK!5e0!3m2!1sen!2sin!4v1717590448232!5m2!1sen!2sin'
      : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121059.04711154514!2d73.78056548298485!3d18.52459859952468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf2e67461101%3A0x828d43bf9d9ee343!2sPune%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1747590448232!5m2!1sen!2sin';
  return (
    <section className="location-section">
      <div className="location-container">
        <div className="location-map-box">
          <div className="location-left">
            <iframe
              key={selectedCity}
              src={mapSrc}
              width="100%"
              height="800"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Location Map"
            ></iframe>
          </div>
        </div>
        <div className="location-content">
          <h2 className="location-title">Location</h2>
          <div className="user-type-toggle-group" style={{ margin: '18px 0',maxWidth:'200px' }}>
            <div
              className={`toggle-button${selectedCity === 'London' ? ' active' : ''}`}
              onClick={() => setSelectedCity('London')}
            >
              London
            </div>
            <div
              className={`toggle-button${selectedCity === 'Pune' ? ' active' : ''}`}
              onClick={() => setSelectedCity('Pune')}
            >
              Pune
            </div>
          </div>
          <p className="location-subtitle">Stop by our office — we'd love to meet you.</p>
          {selectedCity === 'London' && (
            <div className="address-block">
              <p className="address-line">179 Lower Richmond Rd.,</p>
              <p className="address-line">London TW9 4LN,</p>
              <p className="address-line bold">United Kingdom</p>
            </div>
          )}
          {selectedCity === 'Pune' && (
            <div className="address-block">
              <p className="address-line">IT park, Shivaji nagar,</p>
              <p className="address-line">Pune ,Maharastra ,411004</p>
              <p className="address-line bold">India</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Location; 